export const INPUT_DEBOUNCE = 500;
export const TOOLTIP_OPEN_DELAY = 750;
export const TOOLTIP_INTERACTIVE_CLOSE_DELAY = 150;

export const HINT_TOOLTIP_OPEN_DELAY = 300;
export const HINT_TOOLTIP_PADDING_X = 4;
export const HINT_TOOLTIP_PADDING_Y = 2;

export const HOVER_PLATE_OPEN_DELAY = 150;
export const HOVER_PLATE_MOTION_MS = 150;
export const HOVER_PLATE_HEIGHT = 20;
export const HOVER_PLATE_PAD_X = 4;
export const HOVER_PLATE_PAD_Y = 2;
export const HOVER_PLATE_EDGE_GAP = 16;
